import { render, staticRenderFns } from "./successPaiement.vue?vue&type=template&id=5110df9e&scoped=true&"
import script from "./successPaiement.vue?vue&type=script&lang=js&"
export * from "./successPaiement.vue?vue&type=script&lang=js&"
import style0 from "./successPaiement.vue?vue&type=style&index=0&id=5110df9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5110df9e",
  null
  
)

export default component.exports